var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: {
          title: _vm.modalTitle,
          modalId: "modal-lv2",
          showCustomTitle: _vm.isEdittingLocked,
          withBgClickEvent: true,
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "titleLine",
              fn: function () {
                return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c("ModalTabsNew", {
                    attrs: {
                      tabs: _vm.tabs,
                      initialTabIndex: _vm.selectedTabIndex,
                    },
                    on: { tabIndexUpdated: _vm.updateTabIndex },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ selectedTabIndex: tabIndex }) {
                          return [
                            tabIndex === 0
                              ? _c("InPersonVisit", {
                                  attrs: {
                                    project: _vm.project,
                                    projectId: _vm.projectId,
                                    projectActivity: _vm.projectActivity,
                                    contractorId: _vm.contractorId,
                                    currentUserId: _vm.currentUserId,
                                    currentUserRole: _vm.currentUserRole,
                                    companyId: _vm.companyId,
                                    isEdittingLocked: _vm.isEdittingLocked,
                                    showProject: _vm.showProject,
                                    show_cancel_draft_actions:
                                      _vm.show_cancel_draft_actions,
                                    suggestedAssignee: _vm.suggestedAssignee,
                                  },
                                  on: { close: _vm.closeModal },
                                })
                              : tabIndex === 1
                              ? _c("VirtualVisit", {
                                  attrs: {
                                    project: _vm.project,
                                    projectId: _vm.projectId,
                                    projectActivity: _vm.projectActivity,
                                    contractorId: _vm.contractorId,
                                    currentUserId: _vm.currentUserId,
                                    currentUserRole: _vm.currentUserRole,
                                    companyId: _vm.companyId,
                                    isEdittingLocked: _vm.isEdittingLocked,
                                    showProject: _vm.showProject,
                                    show_cancel_draft_actions:
                                      _vm.show_cancel_draft_actions,
                                    suggestedAssignee: _vm.suggestedAssignee,
                                  },
                                  on: { close: _vm.closeModal },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }